<template>
  <div v-if="isAssetTuned" id="assetEditor" class="wt-editor-modal">
    <component
      :is="modalType"
      :overlay-guid="overlayGuid"
      @close="closeModal"
    />
  </div>
</template>

<script>
import app from 'app';
import AssetEditor from '../AssetEditor/AssetEditor.vue';
import VideoTrimming from '../AssetEditor/VideoTrimming.vue';
import AssetPreview from '../AssetPreview/AssetPreview.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'AssetModal',

  props: {
    closeModal: { type: Function },
    overlayGuid: { type: String },
  },

  data() {
    return {
      textOverlayEffect: null,
    };
  },

  destroyed() {
    this.DESTROY_MODULE();
    app.rootStore.unregisterModule('assetEditor');
  },

  computed: {
    ...mapState('assetEditor', ['openedFrom', 'ian', 'workModel']),

    modalType() {
      if (this.isVideoAsset) {
        return VideoTrimming;
      } else if (
        this.openedFrom === 'timeline' ||
        this.openedFrom === 'timeline-change-segment'
      ) {
        return AssetEditor;
      } else {
        return AssetPreview;
      }
    },

    isAssetTuned() {
      return this.ian.isAssetTuned;
    },

    isVideoAsset() {
      return (
        app.assetType.isVIDEO(this.workModel) ||
        app.assetType.isSOCIALVIDEO(this.workModel)
      );
    },
  },

  methods: {
    ...mapActions('assetEditor', ['DESTROY_MODULE']),
  },
};
</script>
